/**
 * Small line icons, drawn on a 24×24 grid and inheriting the text color.
 * All are decorative: every icon sits next to text that says the same thing.
 */
const base = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.7,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
} as const;

/** Sun climbing out of the horizon. */
export function SunriseIcon({ className }: { className?: string }) {
  return (
    <svg {...base} className={className}>
      <path d="M12 4v3M5.6 9.6 7 11M18.4 9.6 17 11M3 18h18M6.5 18a5.5 5.5 0 0 1 11 0" />
    </svg>
  );
}

/** Sun at its highest. */
export function SunIcon({ className }: { className?: string }) {
  return (
    <svg {...base} className={className}>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.3 5.3l1.4 1.4M17.3 17.3l1.4 1.4M18.7 5.3l-1.4 1.4M6.7 17.3l-1.4 1.4" />
    </svg>
  );
}

/** Crescent moon with a star. */
export function MoonIcon({ className }: { className?: string }) {
  return (
    <svg {...base} className={className}>
      <path d="M20 14.2A8 8 0 0 1 9.8 4 8.2 8.2 0 1 0 20 14.2Z" />
      <path d="M17.5 3.5v2.4M16.3 4.7h2.4" />
    </svg>
  );
}

/** Map pin. */
export function PinIcon({ className }: { className?: string }) {
  return (
    <svg {...base} className={className}>
      <path d="M12 21s6.5-5.7 6.5-10.5a6.5 6.5 0 0 0-13 0C5.5 15.3 12 21 12 21Z" />
      <circle cx="12" cy="10.5" r="2.3" />
    </svg>
  );
}

/** Open book, for the halachic method. */
export function BookIcon({ className }: { className?: string }) {
  return (
    <svg {...base} className={className}>
      <path d="M12 6.5v13M12 6.5C10.6 5.2 8.7 4.5 6 4.5H3v13h3c2.7 0 4.6.7 6 2M12 6.5c1.4-1.3 3.3-2 6-2h3v13h-3c-2.7 0-4.6.7-6 2" />
    </svg>
  );
}

/** Two Shabbat candles. */
export function CandlesIcon({ className }: { className?: string }) {
  return (
    <svg {...base} className={className}>
      <path d="M9 9.5c0-1.2 1-1.7 1-3C11.2 7.6 11 9 11 9.5a1 1 0 0 1-2 0ZM15 9.5c0-1.2-1-1.7-1-3-1.2 1.1-1 2.5-1 3a1 1 0 0 0 2 0Z" />
      <path d="M10 12v8M14 12v8M6.5 20h11" />
    </svg>
  );
}

/** Three stars, for nightfall. */
export function StarsIcon({ className }: { className?: string }) {
  return (
    <svg {...base} className={className}>
      <path d="m7 4 .9 2.1L10 7l-2.1.9L7 10l-.9-2.1L4 7l2.1-.9ZM17 9l.7 1.6 1.6.7-1.6.7-.7 1.6-.7-1.6L14.7 11l1.6-.7ZM10.5 15l.8 1.8 1.8.8-1.8.8-.8 1.8-.8-1.8L7.9 17.6l1.8-.8Z" />
    </svg>
  );
}

/** Hourglass, for a fast. */
export function FastIcon({ className }: { className?: string }) {
  return (
    <svg {...base} className={className}>
      <path d="M7 3h10M7 21h10M8 3v3.5c0 2 4 3.7 4 5.5 0-1.8 4-3.5 4-5.5V3M8 21v-3.5c0-2 4-3.7 4-5.5 0 1.8 4 3.5 4 5.5V21" />
    </svg>
  );
}
